import { QUARTER_DATA } from "@containers/Procurement/CreateProcurement/components/CreateProcurementDemandForm";

interface packageBudgetDetailsType {
  [key: string]: any;
  firstQuarterBudget: number;
  fourthQuarterBudget: number;
  id: number;
  procurementMethodId: number;
  secondQuarterBudget: number;
  thirdQuarterBudget: number;
  title: string;
}

export const getQuarterBudget = (
  packageBudgetDetails: packageBudgetDetailsType[],
  selectedQuarter: string,
  packageBudgetId: number,
) => {
  const selectedQuarterResponse = QUARTER_DATA.find(
    (item: any) => item.value === selectedQuarter,
  )?.response;

  if (selectedQuarterResponse) {
    const quarterBudget = packageBudgetDetails.find(
      (item: any) => item.id === packageBudgetId,
    )?.[selectedQuarterResponse];
    return quarterBudget;
  }

  return null;
};
